import api from "./apiHelper";

export const createVoucher = (payload) => {
  return api.post(`/voucher/add`, payload);
};

export const getAllVouchers = () => {
  return api.get(`/voucher`);
};

export const checkVoucherCodeExist = (voucherCode) => {
  return api.get("/voucher/check-voucher-exists?voucherCode=" + voucherCode);
};

export const patchVoucher = (voucherId, payload) => {
  return api.patch(`/voucher/` + voucherId, payload);
};

export const deleteVoucher = (voucherId, payload) => {
  return api.patch(`/voucher/delete/` + voucherId, payload);
};
